import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const BrandGuidelinesStudioForNRO = lazy(() =>
  import("@scenes/BrandGuidelinesStudio").then((module) => ({
    default: module.BrandGuidelinesStudio,
  }))
);

export const brandGuidelinesStudioNRO: NavigationRoutingObject = {
  Component: BrandGuidelinesStudioForNRO,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("brand-guidelines-studio-nro-heading", "Brand Guidelines Studio"),
  pageNameForTracking: () => "Brand Guidelines Studio",
  getDeveloperNavigationAllowed: ({ featureOn }) => featureOn("brand_guidelines_studio"),
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
